/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Loader, RootState, ExamListingResponse } from 'src/store/types';

export const getExamListingLoader = (state: RootState): Loader =>
  state.examListing.loader;
export const getExamListingResponse = (state: RootState): ExamListingResponse =>
  state.examListing.examListingResponse;
export const getExamShowArchived = (state: RootState): boolean =>
  state.examListing.showArchived;
